import {
  FIREBASE_CONFIG,
  firebaseConfig,
  VAPID_KEY,
  vapidKey,
} from "../../openbrix-design-system/utils/firebaseConfig";

export { FIREBASE_CONFIG, firebaseConfig, VAPID_KEY, vapidKey };
export default FIREBASE_CONFIG;
